/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash aa6a933b1b21123d59d8fec2f3b6f2bb */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CreateIrelandTaxiTelematicsLeadInput = {
    givenNames: string;
    lastName: string;
    dateOfBirth: string;
    phoneNumber: string;
    email: string;
    eircode: string;
    attribution?: AttributionInput | null;
};
export type AttributionInput = {
    utmParams?: UTMParamsInput | null;
    testCohorts?: Array<TestingCohortInput> | null;
    featureName?: string | null;
    locationName?: string | null;
};
export type UTMParamsInput = {
    source: string;
    medium?: string | null;
    campaign?: string | null;
    term?: string | null;
    content?: string | null;
    adgroup?: string | null;
};
export type TestingCohortInput = {
    name: string;
    cohort: string;
};
export type useCreateIrelandTaxiTelematicsLeadMutationVariables = {
    input: CreateIrelandTaxiTelematicsLeadInput;
};
export type useCreateIrelandTaxiTelematicsLeadMutationResponse = {
    readonly createIrelandTaxiTelematicsLead: ({
        readonly __typename: "CreateIrelandTaxiTelematicsLeadSuccess";
        readonly viewer: {
            readonly " $fragmentRefs": FragmentRefs<"SessionLayout_viewer">;
        };
        readonly user: {
            readonly customerNumber: string;
            readonly givenNames: string;
        };
    } | {
        readonly __typename: "CreateIrelandTaxiTelematicsLeadError";
        readonly errorMessage: string;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
};
export type useCreateIrelandTaxiTelematicsLeadMutation = {
    readonly response: useCreateIrelandTaxiTelematicsLeadMutationResponse;
    readonly variables: useCreateIrelandTaxiTelematicsLeadMutationVariables;
};



/*
mutation useCreateIrelandTaxiTelematicsLeadMutation(
  $input: CreateIrelandTaxiTelematicsLeadInput!
) {
  createIrelandTaxiTelematicsLead(input: $input) {
    __typename
    ... on CreateIrelandTaxiTelematicsLeadSuccess {
      viewer {
        ...SessionLayout_viewer
      }
      user {
        customerNumber
        givenNames
        id
      }
    }
    ... on CreateIrelandTaxiTelematicsLeadError {
      errorMessage
    }
  }
}

fragment SessionLayout_viewer on Viewer {
  session {
    id
    token
    expiresAt
  }
  currentUser {
    fullName
    customerNumber
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateIrelandTaxiTelematicsLeadInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "customerNumber",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "givenNames",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "type": "CreateIrelandTaxiTelematicsLeadError",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "errorMessage",
      "args": null,
      "storageKey": null
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "useCreateIrelandTaxiTelematicsLeadMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createIrelandTaxiTelematicsLead",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "type": "CreateIrelandTaxiTelematicsLeadSuccess",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "viewer",
                "storageKey": null,
                "args": null,
                "concreteType": "Viewer",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "SessionLayout_viewer",
                    "args": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "useCreateIrelandTaxiTelematicsLeadMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createIrelandTaxiTelematicsLead",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "type": "CreateIrelandTaxiTelematicsLeadSuccess",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "viewer",
                "storageKey": null,
                "args": null,
                "concreteType": "Viewer",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "session",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Session",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "token",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "expiresAt",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "currentUser",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fullName",
                        "args": null,
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "useCreateIrelandTaxiTelematicsLeadMutation",
    "id": null,
    "text": "mutation useCreateIrelandTaxiTelematicsLeadMutation(\n  $input: CreateIrelandTaxiTelematicsLeadInput!\n) {\n  createIrelandTaxiTelematicsLead(input: $input) {\n    __typename\n    ... on CreateIrelandTaxiTelematicsLeadSuccess {\n      viewer {\n        ...SessionLayout_viewer\n      }\n      user {\n        customerNumber\n        givenNames\n        id\n      }\n    }\n    ... on CreateIrelandTaxiTelematicsLeadError {\n      errorMessage\n    }\n  }\n}\n\nfragment SessionLayout_viewer on Viewer {\n  session {\n    id\n    token\n    expiresAt\n  }\n  currentUser {\n    fullName\n    customerNumber\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '375addecc71c98bf193c2d586ea5b817';
export default node;
